import { makeObservable } from 'mobx';
import { EntityStore } from 'shared/stores/EntityStore';

export class JobVacancyStore extends EntityStore {
	constructor() {
		super('job-vacancies');
		makeObservable(this);
	}

	statusOptions = [
		{
			text: 'Open',
			value: 'open'
		},
		{
			text: 'Filled',
			value: 'filled'
		},
		{
			text: 'Cancelled',
			value: 'cancelled'
		}
	];

	cancelReasonOptions = [
		{ text: 'Filled by Another Vendor', value: 'filled_by_another_vendor' },
		{ text: 'Filled Internally', value: 'filled_internally' },
		{ text: 'Changed Job Description', value: 'changed_jd' },
		{ text: 'Client No Reply', value: 'client_no_reply' },
		{ text: 'Proactive', value: 'proactive' },
		{ text: 'No Budget', value: 'no_budget' },
		{ text: 'Company Reorganization', value: 'company_reorganization' },
		{ text: 'Company Re-assigned Budget', value: 'company_reassigned_budget' }
	];

	getCancelReasonByValue = value => {
		return this.cancelReasonOptions.find(reason => reason.value === value);
	};
}

export const jobVacancyStore = new JobVacancyStore();
